import { Theme } from '@emotion/react';

const generateErrorPageStyles = (theme: Theme) => ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '12vh',
    },
    title: {
        marginTop: '12px',
        marginBottom: '12px',
        fontFamily: theme.palette.common.font,
        fontWeight: 500,
        fontSize: '18px',
        letterSpacing: '0.25px',
        color: theme.palette.common.black,
        textAlign: 'center',
    },
    description: {
        fontFamily: theme.palette.common.font,
        fontWeight: 'normal',
        fontSize: '16px',
        letterSpacing: '0.25px',
        textAlign: 'center',
        color: theme.palette.secondary.grey700,
        lineHeight: '20px',
        marginBottom: '16px',
    },
    btnLink: {
        display: 'block',
        background: theme.palette.primary.deepBlue,
        color: theme.palette.common.white,
        padding: '10px 16px',
        textTransform: 'uppercase',
    },
});

export default generateErrorPageStyles;
